import { format } from 'date-fns'

/* Formatting + the plain-text "Copy escalation" summary (artifact copyEscalation). */

export const fmtDT = (d) => (d ? format(new Date(d), 'd MMM, h:mm a') : '—')
export const fmtD = (d) => (d ? format(new Date(d), 'd MMM') : '—')
export const plural = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`

/** Held time: minutes under an hour, whole hours up to 2 days, then days + hours. 0.05 → "3 min", 30 → "30h", 52 → "2d 4h". */
export function fmtHours(h) {
  const v = Number(h) || 0
  if (v <= 0) return '0h'
  if (v < 1) return `${Math.max(1, Math.round(v * 60))} min`
  if (v < 48) return `${Math.round(v)}h`
  const d = Math.floor(v / 24)
  const r = Math.round(v - d * 24)
  return r ? `${d}d ${r}h` : `${d}d`
}

/** Filter-bar state → API filter body. */
/** Merchant / courier filters hold comma-separated ids (multi-select); the API takes lists. */
const idList = (v) => {
  const ids = (v || '').split(',').map((s) => s.trim()).filter(Boolean)
  return ids.length ? ids : undefined
}

export function toApiFilter(tab, f, kpiOwner, page, size) {
  return {
    tab,
    merchantOids: idList(f.merchant),
    courierOids: idList(f.courier),
    owner: f.owner || undefined,
    kpiOwner: kpiOwner || undefined,
    pendingWith: f.pendingWith || undefined,
    memberId: f.memberId || undefined,
    bucket: f.bucket || undefined,
    q: f.q ? f.q.trim() : undefined,
    page,
    size,
  }
}

/** Groups rows by "pending with, member" and writes one sentence per shipment. */
export function buildEscalationText(rows) {
  const groups = {}
  rows.forEach((r) => {
    const k = (r.pendingWith || 'Not attributed') + (r.assignedMemberName ? `, ${r.assignedMemberName}` : '')
    ;(groups[k] = groups[k] || []).push(r)
  })
  let out = `ProShip, Non-ABD EDD breaches as on ${format(new Date(), 'd MMM')}\n${plural(rows.length, 'shipment')}.\n`
  Object.keys(groups).sort().forEach((k) => {
    out += `\nPending with ${k} (${groups[k].length})\n`
    groups[k].forEach((r) => {
      out += `  - ${r.awb || r.orderNo}, ${r.merchantName || ''}, ${r.pickupPin || ''} to ${r.dropPin || ''}. ${r.sentence}\n`
    })
  })
  return out
}

export async function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text)
    return
  }
  const ta = document.createElement('textarea')
  ta.value = text
  ta.setAttribute('readonly', '')
  ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0'
  document.body.appendChild(ta)
  ta.select()
  document.execCommand('copy')
  document.body.removeChild(ta)
}

